import script from "./Tit.vue?vue&type=script&setup=true&lang=js"
export * from "./Tit.vue?vue&type=script&setup=true&lang=js"

import "./Tit.vue?vue&type=style&index=0&id=9a2cbf16&lang=less&scoped=true"
script.__scopeId = "data-v-9a2cbf16"

export default script